import { StreamElement } from 'communication/types/StreamElement.ts';

export enum ResponseArrayObjectTypes {
    Add = 0,
    Remove = 1,
    Update = 2,
    Done = 3,
    Clear = 4,
    BeginBatch = 5,
    EndBatch = 6,
    Error = 101,
    Completed = 102,
}

export type TxImpactResponse =
    | StreamElement<ResponseArrayObjectTypes.Add>
    | StreamElement<ResponseArrayObjectTypes.Remove>
    | StreamElement<ResponseArrayObjectTypes.Update>
    | StreamElement<ResponseArrayObjectTypes.Done>
    | StreamElement<ResponseArrayObjectTypes.Clear>
    | StreamElement<ResponseArrayObjectTypes.BeginBatch>
    | StreamElement<ResponseArrayObjectTypes.EndBatch>
    | (StreamElement<ResponseArrayObjectTypes.Error> & {
          m: string;
          errorOrderIds: string;
      })
    | StreamElement<ResponseArrayObjectTypes.Completed>;
